import { JoomlaInfo, Website, WebsiteApp } from 'src/orchd-client';
import { Icon } from '../Icon';
import { Button } from '../Button';
import { useEffect, useState } from 'react';
import { joomlaApi } from 'src/api_services/wordpress/service';

interface Props {
  website: Website;
  app: WebsiteApp;
  infoPrepopulate?: JoomlaInfo;
}

export const JoomlaButton = ({ website, app, infoPrepopulate }: Props) => {
  const [info, setInfo] = useState<JoomlaInfo>();
  useEffect(() => {
    if (infoPrepopulate) {
      setInfo(infoPrepopulate);
      return;
    }
    joomlaApi
      .getJoomlaInfo({
        websiteId: website.id,
        orgId: website.orgId,
        appId: app.id,
      })
      .then((info) => {
        setInfo(info.data);
      });
  }, [website, app, infoPrepopulate]);

  return (
    <a
      href={`${info?.site_url}/administrator`}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Button
        iconPosition="left"
        variant="primary"
        size="small"
        type="submit"
        icon={<Icon name="joomla-white" />}
        disabled={false}
        onClick={(e) => {
          e.stopPropagation();
        }}
        backgroundColor="joomla"
        backgroundColorHover="joomlaDark"
      >
        Admin
      </Button>
    </a>
  );
};
